module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-跳转-暗.640d9.png";